import React, { PureComponent } from 'react'
import { reduxForm, Field } from 'redux-form'
import { Row, Col, Table, Button, Tooltip, OverlayTrigger, Glyphicon } from 'react-bootstrap'
import IDocCarPagination from '../../commons/iDocCarPagination'
import InputText from '../../commons/form/InputText'
import CampaignTypeModalPage from '../../../containers/masters/CampaignType/CampaignTypeModalPage'
import InputSelect from '../../commons/form/InputSelect'

class CampaignTypeMaster extends PureComponent {
  constructor () {
    super()
    this.state = {
      filter: {
        searchCode: null,
        searchGroupId: null
      }
    }
  }

  getSortIcon (column = '') {
    switch (this.props.filter.orderBy) {
      case '+' + column:
        return 'ico-sort-selected-asc'
      case '-' + column:
        return 'ico-sort-selected-desc'
      default:
        return 'ico-sort'
    }
  }

  changeOrder (field) {
    switch (this.props.filter.orderBy) {
      case `+${field}`:
        this.props.actions.fetchCampaignTypeList({ ...this.state.filter, ...this.props.filter, orderBy: `-${field}` })
        break
      default:
        this.props.actions.fetchCampaignTypeList({ ...this.state.filter, ...this.props.filter, orderBy: `+${field}` })
        break
    }
  }

  handleNameChange (searchCode) {
    if (this.state.filter.searchName !== searchCode) {
      this.setState({ filter: { ...this.state.filter, searchCode } })
    }
  }

  handleGroupChange (searchGroupId) {
    if (this.state.filter.searchGroupId !== searchGroupId) {
      this.setState({ filter: { ...this.state.filter, searchGroupId } })
    }
  }

  searchCampaign () {
    this.props.actions.fetchCampaignTypeList({ ...this.props.filter, ...this.state.filter, page: 1 })
  }

  resetFilters () {
    this.setState({
      filter: {
        searchCode: null,
        searchGroupId: null
      }
    }, () => { this.searchCampaign() })
  }

  render () {
    const {
      t, campaignTypeList, pagesCount, campaignTypeCount, filter,
      combos: { campaignGroup },
      filter: { page },
      actions: { openCampaignTypeModal, fetchCampaignTypeList, recoverCampaignType, deleteCampaignType }
    } = this.props
    const tKey = 'MASTERS.CAMPAIGN_TYPE_MASTERS.'
    const editTooltip = (<Tooltip id="editTooltip">{t(`${tKey}EDIT`)}</Tooltip>)
    const deleteTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}DELETE`)}</Tooltip>)
    const recoverTooltip = (<Tooltip id="deleteTooltip">{t(`${tKey}RECOVER`)}</Tooltip>)
    const hasFilters = (this.state.filter.searchCode || this.state.filter.searchGroupId)
    return (
      <div className="admin-wrapper">
        <CampaignTypeModalPage/>
        <Row className="section-users-header">
          <Col sm={12}>
            <div className="header-panel">
              <h4>{t(`${tKey}CAMPAIGN_TYPE`)}</h4>
            </div>
          </Col>
        </Row>
        <Row>
          <div className="search-form">
            <span className="title-search"><i className="ico-search" /> {t(`${tKey}SEARCH_TITLE`)}</span>
            <Row>
              <Field
                name="filters.code"
                colSm={4}
                controlLabel={t(`${tKey}CODE`)}
                placeholder={t(`${tKey}CODE`)}
                component={InputText}
                onInputChange={(value) => this.handleNameChange(value)}
              />
              <Field
                name="filters.campaignGroupId"
                colSm={4}
                controlLabel={t(`${tKey}GROUPTYPE`)}
                placeholder={t(`${tKey}GROUPTYPE`)}
                valueKey="id"
                labelKey="value"
                component={InputSelect}
                options={campaignGroup}
                onInputChange={(value) => this.handleGroupChange(value)}
              />
              <Col sm={4} className="btn-wrapper">
                <p></p>
                <Button
                  className={'btn-white btn-icon btn-input btn-white search-button'}
                  style={{ width: '100%' }}
                  onClick={() => this.searchCampaign()}>
                  <i className="ico-search" />
                  {t(`${tKey}SEARCH_BTN`)}
                </Button>
                <Button
                  className={'btn-icon btn-input ' + (hasFilters ? 'btn-standard' : 'btn-cancel')}
                  onClick={() => {
                    this.props.initialize({})
                    this.resetFilters()
                  }}
                >
                  <i className="ico-cancel" />
                  {t('MASTERS.RESET_BUTTON')}
                </Button>
              </Col>
            </Row>
          </div>
        </Row>
        <Col sm={12} className="col-row  section-users-body">
          <Table className="editable-table" hover responsive>
            <thead>
              <tr>
                <th onClick={() => { this.changeOrder('code') }}>
                  {t(`${tKey}CODE`)}
                  <i className={this.getSortIcon('code')} />
                </th>
                <th onClick={() => { this.changeOrder('description') }}>
                  {t(`${tKey}DETAILS`)}
                  <i className={this.getSortIcon('description')} />
                </th>
                <th onClick={() => { this.changeOrder('groupCode') }}>
                  {t(`${tKey}GROUPTYPE`)}
                  <i className={this.getSortIcon('groupCode')} />
                </th>
                <th onClick={() => { this.changeOrder('classCode') }}>
                  {t(`${tKey}CLASSTYPE`)}
                  <i className={this.getSortIcon('classCode')} />
                </th>
                <th style={{ width: '77px' }}>{t('DOSSIER_COMPONENTS.ACCESSORIES.ACTIONS')}</th>
              </tr>
            </thead>
            <tbody>
              {campaignTypeList && campaignTypeList.map((campaignType, idx) => {
                return (
                  <tr key={idx} className={campaignType.isDeleted ? 'is-deleted' : ''}>
                    <td>{campaignType.typeCode}</td>
                    <td>{campaignType.campaignTypeLanguage && campaignType.campaignTypeLanguage.length > 0 ? campaignType.campaignTypeLanguage.find(lang => (lang.languageId ? lang.languageId : '') === this.props.languageSelected)?.description : ''}</td>
                    <td>{campaignType.campaignGroupCode}</td>
                    <td>{campaignType.campaignClassCode}</td>
                    <td>
                      {!campaignType.isDeleted ? (
                        <div>
                          <a onClick={() => openCampaignTypeModal(campaignType)}>
                            <OverlayTrigger placement="left" overlay={editTooltip}>
                              <i className="ico-edit-white" />
                            </OverlayTrigger>
                          </a>
                          <a onClick={() => deleteCampaignType(campaignType.campaignTypeId)}>
                            <OverlayTrigger placement="left" overlay={deleteTooltip}>
                              <i className="ico-trash" />
                            </OverlayTrigger>
                          </a>
                        </div>
                      ) : (
                        <a onClick={() => recoverCampaignType(campaignType.campaignTypeId)}>
                          <OverlayTrigger placement="left" overlay={recoverTooltip}>
                            <Glyphicon glyph="repeat" />
                          </OverlayTrigger>
                        </a>
                      )}
                    </td>
                  </tr>)
              })
              }
              {(campaignTypeList === null || campaignTypeList === undefined || campaignTypeList.length === 0) &&
            <tr>
              <td colSpan={10}><h2>{t(`${tKey}RESULTS_NOT_FOUND`)}</h2></td>
            </tr>}
              <tr className="button-table-wrapper">
                <td>
                  <Button
                    className="btn-editable-table btn-standard"
                    onClick={() => openCampaignTypeModal()}>
                  + {t(`${tKey}ADD`)}
                  </Button>
                </td>
              </tr>
            </tbody>
          </Table>
          <div className="section-users-footer">
            <nav key={1} className="text-center">
              <IDocCarPagination
                id="btn_pag_sales"
                page={page}
                pagesCount={pagesCount}
                totalRows={campaignTypeCount}
                onSelectAction={(value) => fetchCampaignTypeList({ ...filter, ...this.state.filter, page: value })}
              />
            </nav>
          </div>
        </Col>
      </div>
    )
  }
}

export default reduxForm({
  form: 'listCampaignType'
})(CampaignTypeMaster)
